import React from "react"
import { useTranslation } from "react-i18next"
import { addDays } from 'date-fns'

import "react-datepicker/dist/react-datepicker.css"

import { FormButtons, Button, DatePickerInput, PortalForm } from '@portal/kit/pkg/components'


export default function UnsubscribeForm({ cancel, isLoading, handleSubmit }) {
  const { t } = useTranslation()

  return (
    <PortalForm onSubmit={handleSubmit}>
      <p>
        {t('subscription.resiliation.explanation')}
      </p>
      <DatePickerInput
        required
        datePickerProps={{ minDate: addDays(new Date(), 10) }}
        placeholder={t("subscription.resiliation.date_placeholder")}
        name="resiliation_date"
      />
      <FormButtons>
        <Button classType="cancelRed" onClick={cancel}>{t('form.cancel')}</Button>
        <Button type="submit" classType="error" isLoading={isLoading}>{t('form.confirm')}</Button>
      </FormButtons>
    </PortalForm>
  )
}
